"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { MessageBox } from "element-ui";
export class UiConfirm {
  static tips(options) {
    return __async(this, null, function* () {
      return MessageBox(__spreadValues({}, options));
    });
  }
  static alert(message, title, options) {
    return __async(this, null, function* () {
      return MessageBox.alert(message, title, __spreadProps(__spreadValues({}, options), {
        confirmButtonClass: "btn-main",
        roundButton: true
      }));
    });
  }
  static confirm(message, title, options) {
    return __async(this, null, function* () {
      return MessageBox.confirm(message, title, __spreadProps(__spreadValues({}, options), {
        confirmButtonClass: "btn-main",
        roundButton: true
      }));
    });
  }
  static warnconfirm(message, title, options) {
    return __async(this, null, function* () {
      return MessageBox.confirm(message, title, __spreadProps(__spreadValues({}, options), {
        confirmButtonClass: "el-button--warning",
        roundButton: true
      }));
    });
  }
  static prompt(message, title, options) {
    return __async(this, null, function* () {
      return MessageBox.prompt(message, title, __spreadProps(__spreadValues({}, options), {
        confirmButtonClass: "btn-main",
        roundButton: true
      }));
    });
  }
}
